export const scopeKey = 'BID Partner';
export const dubaiChamberScopeKey = 'Dubai Chamber Intranet';

export const personalAndContactProfileDetails = [
    {
        label: 'First Name*',
        name: 'requestorFirstName',
        type: 'text',
        required: true,
        placeholder: 'First Name',
        errorMessage: 'First Name',
        component: 'input',
        disabled: true
    },
    {
        label: 'Last Name*',
        name: 'requestorLastName',
        type: 'text',
        required: true,
        placeholder: 'Last Name',
        errorMessage: 'Last Name',
        component: 'input',
        disabled: true
    },
    {
        label: 'Work Email*',
        name: 'requestorWorkEmail',
        required: true,
        type: 'text',
        placeholder: 'Enter Work Email',
        errorMessage: 'Work Email',
        component: 'input',
        disabled: true
    }
];
export const personalAndContactDetails = [
    {
        label: 'First Name*',
        name: 'contactFirstName',
        type: 'text',
        required: true,
        placeholder: 'First Name',
        errorMessage: 'First Name',
        component: 'input'
    },
    {
        label: 'Last Name*',
        name: 'contactLastName',
        type: 'text',
        required: true,
        placeholder: 'Last Name',
        errorMessage: 'Last Name',
        component: 'input'
    },
    {
        label: 'Job Title*',
        name: 'requestorJobTitle',
        type: 'text',
        required: true,
        placeholder: 'Enter Job Title',
        errorMessage: 'Job Title',
        component: 'input'
    },
    {
        label: 'Mobile Number*',
        name: 'requestorMobileNumber',
        required: true,
        type: 'phone',
        placeholder: 'Enter Mobile Number',
        errorMessage: 'Mobile Number'
    },
    {
        label: 'Work Email*',
        name: 'contactWorkEmail',
        required: true,
        type: 'text',
        placeholder: 'Enter Work Email',
        errorMessage: 'Work Email',
        component: 'input'
    },
    {
        label: 'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy?*',
        name: 'whereYourCompanyHearAboutBIDProgram',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage:
            'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy',
        component: 'input'
    },
    {
        label: 'Please specify how you heard about the Business in Dubai Program*',
        name: 'otherValueForBIDProgramReference',
        required: true,
        type: 'text',
        placeholder: 'Enter how you heard about the Business in Dubai Program',
        errorMessage: 'How you heard about the Business in Dubai Program',
        component: 'input'
    }
];

export const personalAndContactDetails1 = [
    {
        label: 'First Name*',
        name: 'requestorFirstName',
        type: 'text',
        required: true,
        placeholder: 'First Name',
        errorMessage: 'First Name',
        component: 'input'
    },
    {
        label: 'Last Name*',
        name: 'requestorLastName',
        type: 'text',
        required: true,
        placeholder: 'Last Name',
        errorMessage: 'Last Name',
        component: 'input'
    },
    {
        label: 'Job Title*',
        name: 'requestorJobTitle',
        type: 'text',
        required: true,
        placeholder: 'Enter Job Title',
        errorMessage: 'Job Title',
        component: 'input'
    },
    {
        label: 'Mobile Number*',
        name: 'requestorMobileNumber',
        required: true,
        type: 'phone',
        placeholder: 'Enter Mobile Number',
        errorMessage: 'Mobile Number'
    },
    {
        label: 'Work Email*',
        name: 'requestorWorkEmail',
        required: true,
        type: 'text',
        placeholder: 'Enter Work Email',
        errorMessage: 'Work Email',
        component: 'input'
    },
    {
        label: 'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy?*',
        name: 'whereYourCompanyHearAboutBIDProgram',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage:
            'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy',
        component: 'input'
    },
    {
        label: 'Please specify how you heard about the Business in Dubai Program*',
        name: 'otherValueForBIDProgramReference',
        required: true,
        type: 'text',
        placeholder: 'Enter how you heard about the Business in Dubai Program',
        errorMessage: 'How you heard about the Business in Dubai Program',
        component: 'input'
    }
];

export const getBasicBusinessDetails = (values: any) => {
    const isUAECompany = values?.uaeOfficeReference === 'yes';
    const isDubai = values?.registeredCompanyEmiratesReference === 'dubai';
    const isDubaiMember = values?.dubaiChamberMemberReference === 'yes';

    const fields: any = [
        {
            label: 'Do you have register company in UAE?*',
            name: 'uaeOfficeReference',
            type: 'select',
            required: true,
            placeholder: 'Select an option',
            errorMessage: 'Do you have register company in UAE',
            component: 'input'
        }
    ];

    // UAE Company = YES
    if (isUAECompany) {
        fields.push({
            label: 'In which Emirate company is registered?*',
            name: 'registeredCompanyEmiratesReference',
            type: 'select',
            required: true,
            placeholder: 'Select an option',
            errorMessage: 'In which Emirate company is registered',
            component: 'input'
        });

        // Dubai specific
        if (isDubai) {
            fields.push({
                label: 'Are you a Dubai Chamber member?*',
                name: 'dubaiChamberMemberReference',
                type: 'select',
                required: true,
                placeholder: 'Select an option',
                errorMessage: 'Are you a Dubai Chamber member',
                component: 'input'
            });

            if (isDubaiMember) {
                fields.push({
                    label: 'Enter the Dubai Chamber Membership number*',
                    name: 'membershipNumber',
                    required: true,
                    type: 'text',
                    placeholder: 'Membership Number',
                    errorMessage: 'Membership Number'
                });
            }
        }

        // Trade License (Dubai & Non-Dubai)
        fields.push({
            label: 'Trade License Number',
            name: 'tradeLicenseNumber',
            required: false,
            type: 'text',
            placeholder: 'License Number',
            errorMessage: 'License Number'
        });
    }

    fields.push(
        {
            label: 'Your Business Name*',
            name: 'requestorBusinessName',
            type: 'text',
            required: true,
            placeholder: 'Enter Business Name',
            errorMessage: 'Your Business Name',
            component: 'input'
        },
        {
            label: 'Country of Origin*',
            name: 'requestorCountryOrOrigin',
            required: true,
            type: 'select',
            placeholder: 'Select an option',
            errorMessage: 'Country of Origin'
        },
        {
            label: 'City*',
            name: 'requestorCity',
            required: true,
            type: 'text',
            placeholder: 'Enter city name',
            errorMessage: 'City',
            component: 'input'
        },
        {
            label: 'Is the business owned or co-founded by a UAE national?*',
            name: 'businessOwnedOrCofoundedByUAE',
            type: 'select',
            required: true,
            placeholder: 'Select an option',
            errorMessage:
                'Is the business owned or co-founded by a UAE national',
            component: 'input'
        },
        {
            label: 'Year of Business Incorporation (When was your company established?)*',
            name: 'requestorBusinessIncorporationYear',
            required: true,
            type: 'text',
            placeholder: 'Enter year',
            errorMessage: 'Year of Business Incorporation',
            component: 'input'
        },
        {
            label: 'Company Website URL*',
            name: 'requestorCompanyWebsiteURL',
            required: true,
            type: 'text',
            placeholder: 'Enter company website',
            errorMessage: 'Company Website URL',
            component: 'input'
        }
    );

    return fields;
};

export const businessProfileDetails = [
    {
        label: 'Please Select the industry sector that best represents your tech business*',
        name: 'requestorTechBusinessIndustrySector',
        type: 'select',
        required: true,
        placeholder: 'Select an option',
        errorMessage:
            'The industry sector that best represents your tech business',
        component: 'input'
    },
    {
        label: 'Select your industry vertical*',
        name: 'requestorIndustryVertical',
        type: 'select',
        required: true,
        placeholder: 'Select an option',
        errorMessage: 'Industry vertical',
        component: 'input'
    },
    {
        label: 'Please specify other industry vertical*',
        name: 'otherIndustryVertical',
        required: true,
        type: 'text',
        placeholder: 'Enter other industry vertical',
        errorMessage: 'Other industry vertical',
        component: 'input'
    },
    {
        label: 'Number of Employees Globally*',
        name: 'numberOfEmployees',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'Number of Employees'
    },
    {
        label: 'Type of Business Model*',
        name: 'requestorBusinessModelType',
        required: true,
        type: 'select',
        placeholder: 'Select Business Model',
        errorMessage: 'Type of Business Model',
        component: 'input'
    },
    {
        label: 'Please specify other Business Model*',
        name: 'otherTypeOfBusinessModel',
        required: true,
        type: 'text',
        placeholder: 'Enter other Business Model',
        errorMessage: 'Other Business Model',
        component: 'input'
    },
    {
        label: 'Annual Revenue (in USD)*',
        name: 'requestorAnnualRevenue',
        required: true,
        type: 'select',
        placeholder: 'Select Annual Revenue',
        errorMessage: 'Annual Revenue',
        component: 'input'
    },
    {
        label: 'Current business valuation (in USD)*',
        name: 'requestorCurrentBusinessValuation',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'Current business valuation',
        component: 'input'
    },
    {
        label: 'Please provide information about the current funding stage of your company*',
        name: 'requestorCompanyCurrentFundingStage',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage:
            'Information about the current funding stage of your company',
        component: 'input'
    },
    {
        label: 'Please specify the alternative funding source*',
        name: 'otherCompanyCurrentFundingStage',
        required: true,
        type: 'text',
        placeholder: 'Enter alternative funding details',
        errorMessage: 'Please specify the alternative funding source',
        component: 'input'
    },
    {
        label: 'Please select the countries outside your country headquarters where you have offices in*',
        name: 'requestorOutsideHeadquarterCountires',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select an option',
        errorMessage:
            'Countries outside your country headquarters where you have offices in',
        component: 'input'
    },
    {
        label: 'Please upload your Corporate Presentation*',
        name: 'corporatePresentation',
        required: true,
        type: 'file',
        placeholder: 'Enter Designation',
        errorMessage: 'Corporate Presentation'
    },
    {
        label: 'Please select the size of the past collaboration and clients you have worked with*',
        name: 'requestorPastCollaborationAndClientSize',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage:
            'Size of the past collaboration and clients you have worked with',
        component: 'input'
    },
    {
        label: 'List key clients you have worked with in the past that you are hoping to find the equivalent of in Dubai (Please specify brands or company names)*',
        name: 'requestorClientsListKey',
        required: true,
        type: 'text',
        placeholder: 'Enter Designation',
        errorMessage:
            'List key clients you have worked with in the past that you are hoping to find the equivalent of in Dubai',
        component: 'textarea'
    }
];
export const dubaiMarketDetails = [
    {
        label: 'Do you sell your products or services in Dubai or UAE today?*',
        name: 'requestorAnswerForTodaysSellInDubaiOrUAE',
        type: 'select',
        required: true,
        placeholder: 'Select an option',
        errorMessage:
            'Do you sell your products or services in Dubai or UAE today',
        component: 'input'
    },
    {
        label: 'Please specify your current sales or business presence status in Dubai or the UAE*',
        name: 'otherAnswerForTodaySell',
        type: 'text',
        required: true,
        placeholder:
            'Enter your current sales or business presence status in Dubai or the UAE',
        errorMessage:
            'Your current sales or business presence status in Dubai or the UAE',
        component: 'input'
    },
    {
        label: 'Are there specific entities in Dubai that you would ideally like to be introduced to? (Provide the name of the specific organization and/or company)*',
        name: 'introduceRequestorSpecificEntitiesInDubai',
        type: 'text',
        required: true,
        placeholder: 'Enter name of the specific organization and/or company',
        errorMessage:
            'Are there specific entities in Dubai that you would ideally like to be introduced to',
        component: 'input'
    },
    {
        label: 'Have you reached out to them in the past?*',
        name: 'requestorReachedOutThemInPast',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'Have you reached out to them in the past'
    },
    {
        label: 'Please provide more details about your outreach*',
        name: 'otherSpecificationForReachedOut',
        type: 'text',
        required: true,
        placeholder: 'Enter more details about your outreach',
        errorMessage: 'More details about your outreach',
        component: 'input'
    },
    {
        label: 'What business categories do you want to be connected with in Dubai?*',
        name: 'requestorWantedCategoriesToBeConnected',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select an option',
        errorMessage: 'business categories',
        component: 'input'
    },
    {
        label: 'Please specify the business categories you would like to connect with in Dubai*',
        name: 'otherCategoriesWantedToConnectInDubai',
        type: 'text',
        required: true,
        placeholder:
            'Enter business categories you would like to connect with in Dubai',
        errorMessage:
            'Business categories you would like to connect with in Dubai',
        component: 'input'
    },
    {
        label: 'How ready are you to open a company in Dubai?*',
        name: 'howRequestorAreReadyToOpenCompany',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'How ready are you to open a company in Dubai',
        component: 'input'
    },
    {
        label: 'Please specify your current plans regarding opening a company in Dubai*',
        name: 'otherAnswerForDubaiStartup',
        type: 'text',
        required: true,
        placeholder:
            'Enter your current plans regarding opening a company in Dubai',
        errorMessage: 'Your current plans regarding opening a company in Dubai',
        component: 'input'
    },
    {
        label: 'Please select the technology readiness level of your products*',
        name: 'productTechnologyReadiness',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'Your technology readiness level of your products',
        component: 'input'
    },
    {
        label: 'What are your biggest challenges in doing business in the UAE?*',
        name: 'requestorBiggestChallangesInUAEStratup',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select an option',
        errorMessage: 'biggest challenges in doing business in the UAE',
        component: 'input'
    },
    {
        label: 'Please specify the challenges your business is facing in the UAE*',
        name: 'otherAnswerForChallanges',
        type: 'text',
        required: true,
        placeholder: 'Enter challenges your business is facing in the UAE',
        errorMessage: 'Challenges your business is facing in the UAE',
        component: 'input'
    },
    {
        label: 'Please share a One-Line Summary explaining your business (Write 10 to 15 words, allowing for a concise and impactful summary)*',
        name: 'requestorBusinessExplanation',
        required: true,
        type: 'text',
        placeholder: 'Enter One-Line Summary',
        errorMessage: 'One-Line Summary',
        component: 'textarea'
    }
];
export const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};
export interface TableHeadData {
    name: string;
    key: string;
    isDateField?: boolean;
    fromDate?: string;
    toDate?: string;
}

export interface TabItem {
    id: number;
    title: string;
    statusKey: string;
    tooltip?: string;
}
export const customerVisibleTabs: TabItem[] = [
    { id: 0, title: 'All', statusKey: 'all', tooltip: 'All Delegates' },
    {
        id: 1,
        title: 'Upcoming',
        statusKey: 'upcoming',
        tooltip: 'Upcoming'
    },
    {
        id: 2,
        title: 'Completed',
        statusKey: 'completed',
        tooltip: 'Completed'
    }
];
export const applicationTableVisibleTabs: TabItem[] = [
    { id: 0, title: 'All', statusKey: 'all', tooltip: 'All Delegates' },
    {
        id: 1,
        title: 'In Progress',
        statusKey: 'inProgess',
        tooltip: 'In-Progress'
    },
    {
        id: 2,
        title: 'Completed',
        statusKey: 'completed',
        tooltip: 'Completed'
    }
];
export const meetingListTableColumn: TableHeadData[] = [
    {
        name: 'Application Number',
        key: 'requestId'
    },
    {
        name: 'Company Name',
        key: 'companyName'
    },
    {
        name: 'Meeting Date',
        key: 'meetingDate'
    },
    {
        name: 'Action',
        key: 'details'
    }
];
export const applicationListTableColumn: TableHeadData[] = [
    // {
    //     name: 'Requested Service',
    //     key: 'requestedService'
    // },
    // {
    //     name: 'Request Date',
    //     key: 'requestDate'
    // },
    // {
    //     name: 'Status',
    //     key: 'status'
    // },
    {
        name: 'Application Number',
        key: 'id'
    },
    {
        name: 'Requested Service',
        key: 'requestorWantedCategoriesToBeConnected'
    },
    {
        name: 'Request Date',
        key: 'requestDate'
    },
    {
        name: 'Status',
        key: 'matchMakingStatus'
    },
    {
        name: 'Action',
        key: 'details'
    }
];
export const upComingMeetingListTableColumn: TableHeadData[] = [
    {
        name: 'Date and Time',
        key: 'meetingDateTime'
    }
    // {
    //     name: 'Location (online or In-Person)',
    //     key: 'location'
    // }
];
export const secondaryButtonStyle = {
    '--parent-bg-background': '#003764',
    '--bg-cut-background': '#fff',
    color: '#003764'
} as React.CSSProperties;
